import { NavSection } from './DashboardLayout';
import { Icons } from './dashboardIcons';

export const createEmployeeNavSections = (
  t: any,
  isActive: (href: string) => boolean,
): NavSection[] => {
  return [
    {
      title: 'Dashboard',
      items: [
        {
          name: t('dashboard.myDashboard') || 'My Dashboard',
          href: '/employee-dashboard',
          icon: Icons.grid,
          current: isActive('/employee-dashboard'),
        },
        {
          name: t('dashboard.timesheet') || 'Timesheet',
          href: '/timesheet',
          icon: Icons.clock,
          current: isActive('/timesheet'),
        },
        {
          name: t('calendar.myCalendar') || 'Calendar',
          href: '/calendar',
          icon: Icons.calendar,
          current: isActive('/calendar'),
        },
        {
          name: t('timeOff.myTimeOff') || 'Time Off',
          href: '/my-time-off',
          icon: Icons.calendar,
          current: isActive('/my-time-off'),
        },
        {
          name: t('expense.myExpenses') || 'My Expenses',
          href: '/expenses',
          icon: Icons.dollarSign,
          current: isActive('/expenses'),
        },
      ],
    },
  ];
};
